import { forwardRef, type SVGProps } from 'react';

export const SignatureCheckIcon = forwardRef<
  SVGSVGElement,
  SVGProps<SVGSVGElement>
>(function SignatureCheckIcon(props, ref) {
  return (
    <svg
      ref={ref}
      fill="none"
      viewBox="0 0 60 61"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1553_10614)">
        <circle
          cx="30"
          cy="30.5"
          r="28"
          stroke="currentColor"
          strokeWidth="4"
        />
        <path
          d="M32.9798 35.3753C34.3968 35.3753 34.9493 36.0069 35.3685 37.4066L35.4422 37.6633C35.6405 38.3751 35.7585 38.5885 35.998 38.6871C36.2785 38.803 36.4649 38.7868 36.7595 38.6351L36.9188 38.5463C36.9762 38.5116 37.038 38.4715 37.1095 38.4249L37.8277 37.9363C38.495 37.4976 39.0952 37.2073 39.8243 37.0253C40.0321 36.9765 40.2507 37.0114 40.4329 37.1226C40.6152 37.2337 40.7464 37.412 40.7982 37.6191C40.85 37.8261 40.8182 38.0453 40.7098 38.2291C40.6013 38.4129 40.4249 38.5467 40.2186 38.6015C39.7798 38.713 39.3609 38.8921 38.9771 39.1323L38.6543 39.3382L38.1343 39.6935C37.9321 39.8355 37.7211 39.9647 37.5027 40.0803C36.8061 40.4378 36.1269 40.4984 35.3794 40.1886C34.5712 39.8571 34.2462 39.3447 33.9418 38.3253L33.7728 37.737C33.5767 37.0989 33.4424 37.0003 32.9798 37.0003C32.644 37.0003 32.2973 37.1683 31.8217 37.5669L31.6224 37.7413L30.6246 38.6893C29.0993 40.1236 27.7982 40.8202 25.936 40.8202C24.1095 40.8202 22.53 40.545 21.204 39.9871L24.3965 39.1161C24.8808 39.1681 25.3943 39.1952 25.936 39.1952C27.2175 39.1952 28.1373 38.7456 29.2802 37.7186L29.5597 37.4597L30.136 36.9072C30.3917 36.6613 30.5845 36.4847 30.7774 36.3222C31.5184 35.7014 32.1911 35.3753 32.9798 35.3753ZM37.6165 20.7178C38.3431 21.4449 38.7513 22.4308 38.7513 23.4587C38.7513 24.4866 38.3431 25.4725 37.6165 26.1995L37.3045 26.5137C38.5514 28.0303 38.507 29.6402 37.3467 30.8037L35.179 32.9703C35.0264 33.1226 34.8196 33.2081 34.604 33.2079C34.3885 33.2077 34.1818 33.1218 34.0295 32.9693C33.8773 32.8167 33.7918 32.6099 33.792 32.3943C33.7922 32.1788 33.8781 31.9721 34.0306 31.8198L36.1962 29.6553C36.7216 29.1278 36.7812 28.4745 36.1529 27.6631L26.8178 37.0003C26.5176 37.3006 26.1441 37.5172 25.7345 37.6287L20.1932 39.1399C20.0551 39.1774 19.9095 39.1777 19.7712 39.1409C19.6329 39.104 19.5068 39.0312 19.4056 38.93C19.3045 38.8287 19.2319 38.7025 19.1952 38.5642C19.1584 38.4259 19.1589 38.2803 19.1965 38.1422L20.7067 32.5998C20.8184 32.1906 21.035 31.8175 21.335 31.5176L32.1348 20.7178C32.4948 20.3578 32.9221 20.0721 33.3925 19.8772C33.8629 19.6823 34.367 19.582 34.8762 19.582C35.3853 19.582 35.8895 19.6823 36.3598 19.8772C36.8302 20.0721 37.2576 20.3578 37.6175 20.7178H37.6165Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1553_10614">
          <rect
            fill="white"
            height="60"
            transform="translate(0 0.5)"
            width="60"
          />
        </clipPath>
      </defs>
    </svg>
  );
});
